import React from 'react';
import Notification from '../messagerie_user/notification';

function AffichageInfoJoueur(props) {
  const apiUrl = process.env.REACT_APP_API_URL;


  return (
    <>
      {props.userData && (
        <>
          {props.equipe && props.equipe.joueur && (
            <div className="main equipes_info">
              <Notification userData={props.userData} />
              <div className="joueur">
                <div className="image7">
                  <img
                    src={`${apiUrl}/image/equipe/${props.equipe.joueur[0].logo}`}
                    alt=""
                    width="100"
                    height="100"
                  />
                </div>
                <div className="nbr">N°{props.equipe.joueur[0].numero}</div>
                <div className="nom">
                  <a href={`/${props.type}/equipe/${props.equipe.joueur[0].id_equipe}`}>
                    <span style={{ textTransform: 'capitalize' }}>{props.equipe.joueur[0].poste}</span> du {props.equipe.joueur[0].nom_equipe} ({props.equipe.joueur[0].categorie})
                  </a>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <table>
                    <tbody>
                      <tr>
                        <td>Nom</td>
                        <td>:</td>
                        <td>{props.equipe.joueur[0].nom}</td>
                      </tr>
                      <tr>
                        <td>Prenom</td>
                        <td>:</td>
                        <td>{props.equipe.joueur[0].prenom}</td>
                      </tr>
                      <tr>
                        <td>Date de naissance</td>
                        <td>:</td>
                        <td>{props.equipe.joueur[0].date}</td>
                      </tr>
                      <tr>
                        <td>Numéro de téléphone</td>
                        <td>:</td>
                        <td>{props.equipe.joueur[0].contact}</td>
                      </tr>
                      <tr>
                        <td>Taille</td>
                        <td>:</td>
                        <td>{props.equipe.joueur[0].taile} m</td>
                      </tr>
                      <tr>
                        <td>Poid</td>
                        <td>:</td>
                        <td>{props.equipe.joueur[0].poid} Kg</td>
                      </tr>
                      <tr>
                        <td>Pied fort</td>
                        <td>:</td>
                        <td>{props.equipe.joueur[0].pied_fort}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default AffichageInfoJoueur;
